'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter, useSearchParams } from 'next/navigation';
import ArrowForward from '@mui/icons-material/ArrowForward';
import CourseNavigationFooter from '../../../[chapterSlug]/_components/CourseNavigationFooter';
import CategoryButton from '../../../[chapterSlug]/_components/CategoryButton';
import getNextChapter from '../../../[chapterSlug]/_utils/getNextChapter';
import getFooterInformation from '../../../[chapterSlug]/_utils/getFooterInformation';
import { useChapterContext } from '../../../[chapterSlug]/_contexts/ChapterContext';
import { useExerciseContext } from '../_contexts/ExerciseContext';
const CourseFooterWrapper = () => {
  const $ = _c(19);
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    course,
    flatToc
  } = useChapterContext();
  const {
    exerciseId
  } = useExerciseContext();
  if (!course) {
    return null;
  }
  const {
    categoryColor
  } = course;
  let nextChapter;
  let t0;
  if ($[0] !== course || $[1] !== exerciseId || $[2] !== flatToc || $[3] !== searchParams) {
    nextChapter = getNextChapter(flatToc as any, exerciseId);
    t0 = getFooterInformation(course as any, nextChapter, searchParams?.toString());
    $[0] = course;
    $[1] = exerciseId;
    $[2] = flatToc;
    $[3] = searchParams;
    $[4] = nextChapter;
    $[5] = t0;
  } else {
    nextChapter = $[4];
    t0 = $[5];
  }
  const {
    label,
    url
  } = t0;
  let t1;
  if ($[6] !== router || $[7] !== url) {
    t1 = () => {
      router.push(url);
      router.refresh();
    };
    $[6] = router;
    $[7] = url;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleClick = t1;
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowForward />;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = nextChapter?.title;
  let t4;
  if ($[10] !== categoryColor || $[11] !== handleClick || $[12] !== label || $[13] !== t3) {
    t4 = <CategoryButton data-testid="course-footer-button" endIcon={t2} onClick={handleClick} title={t3} categoryColor={categoryColor}>{label}</CategoryButton>;
    $[10] = categoryColor;
    $[11] = handleClick;
    $[12] = label;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== categoryColor || $[16] !== nextChapter || $[17] !== t4) {
    t5 = <CourseNavigationFooter categoryColor={categoryColor} nextChapter={nextChapter}>{t4}</CourseNavigationFooter>;
    $[15] = categoryColor;
    $[16] = nextChapter;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default CourseFooterWrapper;